import RSkeleton from 'react-loading-skeleton';

const Skeleton = (props) => <RSkeleton {...props} />;

export default Skeleton;
